import { getEnv } from '../../../environment';
import { useNmfRedirect } from '../../hooks/useNmfRedirect';
import { useNmfTimer } from '../../hooks/useNmfTimer';
import LogoHeader from '../components/LogoHeader';
import ProgressNav from '../components/ProgressNav';

const IntroProductNav = (envName) => {
  const env = getEnv(envName);
  const introProductSteps = [
    { title: 'Confirmation', url: '/gtb-thank-you/shipping' },
    { title: 'Survey', url: '/personal-survey' },
    { title: 'Done', url: null },
  ];

  const {
    lastVisitedCustomizeQuestionId,
    timerType,
    newMemberState,
    loading: timerLoading,
  } = useNmfTimer(env);

  useNmfRedirect(newMemberState, lastVisitedCustomizeQuestionId, env.REACT_APP_BASE_URL, timerType);

  if (timerLoading) {
    return null;
  }

  return (
    <>
      <LogoHeader />
      <ProgressNav steps={introProductSteps} />
    </>
  );
};

export default IntroProductNav;
